goog.provide("shadow.js.shim.module$d3");
goog.provide("module$shadow_js_shim_module$d3");
shadow.js.shim.module$d3 = shadow.js.nativeProvides["d3"] = shadow$bridge("d3");
module$shadow_js_shim_module$d3.default = shadow.js.shim.module$d3;
